import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { Badge } from "../../UI/DesignStandards";
import { AllEventDetailsModal } from "./AllEventDetailsModal";

export const AllEventScoreCell = ({
  score,
  allEventMetadata,
  eventName,
  bowlerName,
  tournamentId,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!allEventMetadata) {
    // Not an all event, just show the score
    return <span>{score?.toLocaleString() || "-"}</span>;
  }

  const { isComplete, presentPrimaryEventCount, requiredPrimaryEventCount } =
    allEventMetadata;

  const handleInfoClick = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="flex items-center justify-center gap-2">
        <span>{score?.toLocaleString() || "-"}</span>
        {!isComplete && (
          <Badge
            variant="default"
            className="text-xs !rounded-lg !bg-brand-cream !text-brand-charcoal border border-brand-charcoal/20"
          >
            {presentPrimaryEventCount}/{requiredPrimaryEventCount}
          </Badge>
        )}
        <button
          onClick={handleInfoClick}
          className="p-1 text-brand-gold-ink hover:text-brand-charcoal hover:bg-brand-cream rounded-lg transition-colors"
          aria-label="View all event details"
          title="View all event breakdown"
        >
          <FaInfoCircle className="w-4 h-4" />
        </button>
      </div>

      <AllEventDetailsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        allEventData={{
          eventName,
          bowlerName,
          allEventMetadata,
          totalScore: score,
          tournamentId,
        }}
      />
    </>
  );
};
